import styled from 'styled-components';
import theme from '../../../assets/styles/theme';

export const Description = styled.div`
  padding-top: ${theme.spacing['spacing-4']};
  padding-bottom: ${theme.spacing['spacing-4']};
  ${({ overflowHidden }) =>
    overflowHidden &&
    `
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  `}
`;
